// Curated emoji set used as the text overlay's optional prefix/suffix "icon" (plain Unicode
// characters render in any Textbox with no special font handling, unlike an icon-font glyph).
// Grouped + keyworded (French) so IconPicker.vue can offer search and category browsing instead
// of one long undifferentiated grid.
export const EMOJI_GROUPS = [
    {
        labelKey: 'dash.post-creator.media-editor.icon-picker.group-popular',
        items: [
            { char: '🔥', keywords: 'feu flamme populaire tendance' },
            { char: '❤️', keywords: 'coeur amour love' },
            { char: '✅', keywords: 'coche valide ok check' },
            { char: '⭐', keywords: 'etoile star favori' },
            { char: '🎉', keywords: 'fete celebration confettis' },
            { char: '👍', keywords: 'pouce like bien approuve' },
            { char: '😂', keywords: 'rire mdr lol' },
            { char: '😍', keywords: 'amour coeur yeux' },
            { char: '🙌', keywords: 'bravo mains celebration' },
            { char: '💯', keywords: 'cent pourcent parfait top' }
        ]
    },
    {
        labelKey: 'dash.post-creator.media-editor.icon-picker.group-faces',
        items: [
            { char: '😀', keywords: 'sourire content heureux' },
            { char: '😉', keywords: 'clin oeil complice' },
            { char: '😎', keywords: 'cool lunettes classe' },
            { char: '🤔', keywords: 'reflexion pense question' },
            { char: '😮', keywords: 'surprise choc' },
            { char: '😢', keywords: 'triste pleure larme' },
            { char: '😱', keywords: 'peur choc cri' },
            { char: '🥳', keywords: 'fete anniversaire celebration' },
            { char: '😴', keywords: 'dort fatigue sommeil' },
            { char: '🤩', keywords: 'etoiles impressionne wahou' }
        ]
    },
    {
        labelKey: 'dash.post-creator.media-editor.icon-picker.group-hearts',
        items: [
            { char: '💖', keywords: 'coeur amour brillant' },
            { char: '💕', keywords: 'coeurs amour' },
            { char: '💔', keywords: 'coeur brise triste rupture' },
            { char: '💗', keywords: 'coeur battement amour' },
            { char: '🧡', keywords: 'coeur orange amitie' },
            { char: '💛', keywords: 'coeur jaune amitie' },
            { char: '💚', keywords: 'coeur vert nature' },
            { char: '💙', keywords: 'coeur bleu confiance' },
            { char: '💜', keywords: 'coeur violet' },
            { char: '🖤', keywords: 'coeur noir' }
        ]
    },
    {
        labelKey: 'dash.post-creator.media-editor.icon-picker.group-symbols',
        items: [
            { char: '⚠️', keywords: 'attention danger alerte' },
            { char: '❗', keywords: 'important exclamation' },
            { char: '❓', keywords: 'question interrogation' },
            { char: '➡️', keywords: 'fleche droite suivant' },
            { char: '⬆️', keywords: 'fleche haut monter' },
            { char: '✨', keywords: 'etincelles brillant magie' },
            { char: '💥', keywords: 'boom explosion impact' },
            { char: '💧', keywords: 'goutte eau larme' },
            { char: '🆕', keywords: 'nouveau new' },
            { char: '🔒', keywords: 'cadenas verrouille prive' }
        ]
    },
    {
        labelKey: 'dash.post-creator.media-editor.icon-picker.group-nature',
        items: [
            { char: '☀️', keywords: 'soleil beau temps ete' },
            { char: '🌙', keywords: 'lune nuit' },
            { char: '⛅', keywords: 'nuage soleil meteo' },
            { char: '🌈', keywords: 'arc en ciel couleurs' },
            { char: '🌸', keywords: 'fleur printemps' },
            { char: '🍀', keywords: 'trefle chance' },
            { char: '🌊', keywords: 'vague mer ocean' },
            { char: '❄️', keywords: 'neige flocon hiver froid' }
        ]
    },
    {
        labelKey: 'dash.post-creator.media-editor.icon-picker.group-food',
        items: [
            { char: '🍕', keywords: 'pizza' },
            { char: '🍔', keywords: 'burger hamburger' },
            { char: '🍰', keywords: 'gateau anniversaire dessert' },
            { char: '☕', keywords: 'cafe boisson' },
            { char: '🍷', keywords: 'vin verre' },
            { char: '🍓', keywords: 'fraise fruit' },
            { char: '🍎', keywords: 'pomme fruit' },
            { char: '🥗', keywords: 'salade sain healthy' }
        ]
    },
    {
        labelKey: 'dash.post-creator.media-editor.icon-picker.group-objects',
        items: [
            { char: '🎁', keywords: 'cadeau offre surprise' },
            { char: '📍', keywords: 'lieu localisation pin' },
            { char: '📸', keywords: 'photo appareil camera' },
            { char: '🎵', keywords: 'musique note son' },
            { char: '💡', keywords: 'idee ampoule astuce' },
            { char: '⏰', keywords: 'horloge reveil temps' },
            { char: '🏆', keywords: 'trophee victoire gagnant' },
            { char: '💰', keywords: 'argent sac promo' }
        ]
    },
    {
        labelKey: 'dash.post-creator.media-editor.icon-picker.group-activities',
        items: [
            { char: '💪', keywords: 'muscle force motivation sport' },
            { char: '🏃', keywords: 'course courir sport' },
            { char: '✈️', keywords: 'avion voyage' },
            { char: '🎬', keywords: 'clap cinema film' },
            { char: '🎮', keywords: 'jeu manette gaming' },
            { char: '📚', keywords: 'livres lecture etude' },
            { char: '🛍️', keywords: 'shopping sac achat' },
            { char: '🏠', keywords: 'maison accueil' }
        ]
    }
]
